import { ORGANIZATION_MANAGEMENT_BASE_PATH } from '@cast/infrastructure-organization';

import { FEATURES_URL_PARAM_NAME } from './_constants';
import { serializeFeatureSelection } from './_utils';
import { DEFAULT_CLOUD_PROVIDER } from './constants';
import type { AllFeatureTypes, SupportedCloudProvider } from './types';

type CreatePermissionsCenterUrlParams = {
  cloudProvider?: SupportedCloudProvider;
  selectedFeatures?: AllFeatureTypes[];
};

export const createPermissionsCenterUrl = ({
  cloudProvider = DEFAULT_CLOUD_PROVIDER,
  selectedFeatures = [],
}: CreatePermissionsCenterUrlParams = {}): string => {
  const path = `${ORGANIZATION_MANAGEMENT_BASE_PATH}/permissions-center/${cloudProvider}`;

  if (!selectedFeatures.length) {
    return path;
  }

  const params = new URLSearchParams({
    [FEATURES_URL_PARAM_NAME]: serializeFeatureSelection(selectedFeatures),
  });

  return `${path}?${params}`;
};
